import React, { useState } from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { TermsContent } from './TermsContent';
import { PrivacyContent } from './PrivacyContent';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-[#0a0a1a] border-t border-white/5 pt-20 pb-10" data-id="element-98">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
          {/* Final CTA */}
          <div className="bg-gradient-to-r from-purple-900/40 to-pink-900/40 rounded-3xl p-8 md:p-16 text-center mb-20 relative overflow-hidden" data-id="element-100">
            <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-101"></div>
            <div className="relative z-10" data-id="element-102">
              <h2 className="text-3xl md:text-4xl font-bold font-orbitron mb-6 text-white" data-id="element-103">
                ¿Listo para llenar tu agenda?
              </h2>
              <p className="text-gray-300 mb-8 max-w-2xl mx-auto text-lg" data-id="element-104">
                Dejá de perder clientes en Instagram. Obtené una página web
                profesional que muestre tus servicios y genere contactos por vos
                24/7.
              </p>
              <a href="#precios" className="inline-block px-8 py-4 rounded-full bg-white text-black font-bold text-lg hover:bg-gray-200 transition-colors shadow-[0_0_20px_rgba(255,255,255,0.3)]" data-id="element-105">
                Solicitar Mi Página Web
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 border-b border-white/5 pb-12" data-id="element-106">
            <div className="col-span-1 md:col-span-2" data-id="element-107">
              <a href="#" className="flex items-center gap-3 mb-6" data-id="element-108">
                <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-14 w-auto object-contain drop-shadow-[0_0_10px_rgba(124,58,237,0.3)]" data-id="element-109" />
              </a>
              <p className="text-gray-400 max-w-sm mb-6" data-id="element-110">
                Ayudamos a negocios y profesionales a conseguir más clientes con
                páginas web que convierten y campañas de Meta Ads optimizadas.
              </p>
              <div className="flex gap-4" data-id="element-111">
                <a href="https://www.instagram.com/azestrategias/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-purple-600 hover:text-white transition-all duration-300" data-id="element-112">
                  <Instagram className="w-5 h-5" data-id="element-113" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61587921394872" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-purple-600 hover:text-white transition-all duration-300" data-id="element-114">
                  <Facebook className="w-5 h-5" data-id="element-115" />
                </a>
              </div>
              <div className="flex gap-4 mt-4" data-id="element-116">
                <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-500 hover:text-purple-400 transition-colors" data-id="element-117">
                  Términos y Condiciones
                </button>
                <span className="text-gray-600" data-id="element-118">•</span>
                <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-500 hover:text-purple-400 transition-colors" data-id="element-119">
                  Privacidad
                </button>
              </div>
            </div>

            <div data-id="element-120">
              <h4 className="text-white font-bold mb-6 font-orbitron" data-id="element-121">
                Enlaces Rápidos
              </h4>
              <ul className="space-y-4" data-id="element-122">
                {['Beneficios', 'Método', 'Testimonios', 'Precios', 'FAQ'].map(item => <li key={item} data-id="element-123">
                      <a href={`#${item.toLowerCase()}`} className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-124">
                        {item}
                      </a>
                    </li>)}
              </ul>
            </div>

            <div data-id="element-125">
              <h4 className="text-white font-bold mb-6 font-orbitron" data-id="element-126">
                Contacto
              </h4>
              <ul className="space-y-4 text-gray-400" data-id="element-127">
                <li data-id="element-128">San José, Costa Rica 🇨🇷</li>
                <li data-id="element-129">
                  <a href="mailto:holaestrategiasaz@gmail.com" className="group block w-full max-w-[220px] overflow-hidden rounded-lg bg-white/5 border border-white/10 hover:border-purple-500/40 hover:bg-white/10 transition-all duration-300 cursor-pointer" data-id="element-130">
                    <div className="flex items-center gap-2 px-3 py-2" data-id="element-131">
                      <Mail className="w-4 h-4 text-purple-400 flex-shrink-0" data-id="element-132" />
                      <div className="overflow-hidden flex-1" data-id="element-133">
                        <div className="animate-marquee whitespace-nowrap text-sm text-gray-300 group-hover:text-purple-300 transition-colors" data-id="element-134">
                          holaestrategiasaz@gmail.com&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;&nbsp;holaestrategiasaz@gmail.com&nbsp;&nbsp;&nbsp;✦&nbsp;&nbsp;&nbsp;
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li data-id="element-135">+506 8531-6690</li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-136">
            <p data-id="element-137">
              © 2026 Estrategias Digitales A-Z. Todos los derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-138">
              <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors" data-id="element-139">
                Términos
              </button>
              <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors" data-id="element-140">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-141">
        <TermsContent data-id="element-142" />
      </LegalModal>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-143">
        <PrivacyContent data-id="element-144" />
      </LegalModal>
    </>;
}